import React from 'react'

interface Props {
  color?: string
  size?: number
}

const Hamburger = React.forwardRef(
  (
    { color = 'currentColor', size = 16, ...rest }: Props,
    ref: React.LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={ref}
        className="h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        stroke={color}
        aria-hidden="true"
        {...rest}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 6h16M4 12h8m-8 6h16"
        />
      </svg>
    )
  }
)

export default Hamburger
